'use client'

import { NotificationBanner } from '@dustin-web/microsite-components/src/banners'
import { useSiteContext } from '@dustin-web/microsite-components/src/hooks'
import { useI18n } from '@dustin-web/microsite-components/src/i18n'
import { isNotNullOrUndefined } from '@dustin-web/microsite-config/src/utils'
import useShoppingCart from '@dustin-web/product-components/src/hooks/dataloader/use-shopping-cart'
import { ProductWithCategoryType } from '@dustin-web/product-components/src/utils/digital-data-types'
import { ProductDigitalData } from '@dustin-web/product-components/src/utils/product-digital-data'
import { Fragment, useEffect, useState } from 'react'
import classnames from 'classnames'
import { ProductType } from '@cartsite-app/src/graphql/generated/graphql-types'

export const TopInfoBanners = () => {
  const { translate } = useI18n()
  const { site, currencyCode } = useSiteContext()
  const { cartItems, totalPriceExcludingVat } = useShoppingCart({
    withRequiredEndUserInformation: true,
  })

  const canAllBeDeliveredImmediately = cartItems.every(
    item => item.product?.availability?.availabilityStatus === 'IMMEDIATE_SHIPPING'
  )
  const showImmediateDeliveryNotAvailable =
    !canAllBeDeliveredImmediately && cartItems.length > 1

  useEffect(() => {
    if (showImmediateDeliveryNotAvailable) {
      if (!window.DigitalData) {
        window.DigitalData = []
      }
      window.DigitalData.push({
        event: 'availability_message',
        availability_message: 'availability-banner-in-cart',
      })
    }
  }, [showImmediateDeliveryNotAvailable])

  useEffect(() => {
    if (productsNonReturnable.length) {
      setShowProductsNonReturnableBox(true)
    }

    ProductDigitalData.pushViewCart(
      cartItems
        .map((x, i) => {
          return x.product
            ? ({
              ...x.product,
              quantity: x.quantity,
              productListIndex: i,
            } as ProductWithCategoryType)
            : null
        })
        .filter(isNotNullOrUndefined),
      currencyCode,
      totalPriceExcludingVat
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [showProductsNonReturnableBox, setShowProductsNonReturnableBox] = useState(true)

  const productsNonReturnable = cartItems.map(x => x.product).filter(p => p?.nonReturnable)

  const topInfoBanners: React.ReactNode[] = []

  const cartContainsOnlyConfigProducts =
    cartItems.length > 0 &&
    cartItems.every(
      x =>
        x.product?.productType === ProductType.Config && !x.product?.availability?.isIncludedInKit
    )

  const generalInformation = translate('Cart_GeneralInformation')
  //  || spoofedUi?.cartGeneralInfo
  if (generalInformation && generalInformation != '') {
    topInfoBanners.push(<NotificationBanner type="INFO" description={generalInformation} />)
  }

  if (showProductsNonReturnableBox && productsNonReturnable.length > 0) {
    topInfoBanners.push(
      <NotificationBanner
        type="INFO"
        closeable
        description={translate('Cart_CartContainsNonReturnableProducts')}
        list={productsNonReturnable.map(
          product =>
            `${product?.displayName}, (${translate('ArticleNumber').toLowerCase()}: ${product?.productErpIdentifier
            })`
        )}
      />
    )
  }

  if (cartContainsOnlyConfigProducts) {
    topInfoBanners.push(
      <NotificationBanner
        type="ERROR"
        description={translate('Cart_CartContainsOnlyConfigProducts')}
      />
    )
  }

  if (showImmediateDeliveryNotAvailable) {
    topInfoBanners.push(
      <div className="delivery-availabilty-cart">
        <NotificationBanner
          type="INFO"
          closeable
          title={translate('Cart_ImmediateDeliveryNotAvailable_Heading')}
          description={
            site == 'DustinNetherlands'
              ? translate('Cart_ImmediateDeliveryNotAvailable_Body_NL')
              : translate('Cart_ImmediateDeliveryNotAvailable_Body')
          }
        />
      </div>
    )
  }

  return (
    <div
      className={classnames({
        'u-pt-24 u-pt-xl-48': topInfoBanners.length === 0,
      })}>
      {topInfoBanners.length > 0 && (
        <div className="u-pt-16 u-pt-xl-48 u-pb-xl-8">
          {topInfoBanners.map((banner, i) => (
            <Fragment key={i}>{banner}</Fragment>
          ))}
        </div>
      )}
    </div>
  )
}
